import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { isNil } from 'lodash';
import { useSnackbar } from 'notistack';
import { CompaniesService } from 'api';
import type { CompanyFundingRounds } from 'api';
import {
  COMPANY_FUNDING_ROUNDS_DEFAULT_ERROR_MESSAGE,
  COMPANY_FUNDING_ROUNDS_QUERY_KEY,
} from 'common/constants/services/companies';

export type { CompanyFundingRounds };

const useGetCompanyFundingRounds = (companyId: number | undefined) => {
  const { enqueueSnackbar } = useSnackbar();

  const { data, isLoading, isError } = useQuery({
    enabled: !isNil(companyId),
    queryFn: () => CompaniesService.apiCompaniesFundingRoundsRead(companyId as number),
    queryKey: [COMPANY_FUNDING_ROUNDS_QUERY_KEY, companyId],
    retry: false,
  });

  useEffect(() => {
    if (isError) {
      enqueueSnackbar(COMPANY_FUNDING_ROUNDS_DEFAULT_ERROR_MESSAGE, { variant: 'error' });
    }
  }, [isError, enqueueSnackbar]);

  return { data, isLoading, isError };
};

export default useGetCompanyFundingRounds;
